import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle", "icon"]

  connect() {
    // Start collapsed on mobile
    if (window.innerWidth <= 768) {
      this.contentTarget.classList.add('hidden')
    }
  }

  toggle() {
    const isHidden = this.contentTarget.classList.contains('hidden')

    if (isHidden) {
      // Expand
      this.contentTarget.classList.remove('hidden')
      if (this.hasToggleTarget) {
        this.toggleTarget.textContent = 'Masquer les graphiques'
      }
      if (this.hasIconTarget) {
        this.iconTarget.classList.add('rotate-180')
      }
    } else {
      // Collapse
      this.contentTarget.classList.add('hidden')
      if (this.hasToggleTarget) {
        this.toggleTarget.textContent = 'Voir les graphiques'
      }
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove('rotate-180')
      }
    }
  }
}
